import type { MedicationStatementModel } from '@ctw/shared/api/fhir/models/medication-statement';
import { CopyToClipboard } from '@ctw/shared/components/copy-to-clipboard';
import type { LegacyTableColumn } from '@ctw/shared/components/tables/legacy-table';
import {
  RenderSyncedWithRecordIcon,
  ResourceTitleColumn,
} from '@ctw/shared/content/resource/resource-title-column';
import { tw } from '@ctw/shared/utils/tailwind';

export const patientMedicationsAllColumns = (
  builderId: string,
): Array<LegacyTableColumn<MedicationStatementModel>> => [
  {
    title: 'Name',
    widthPercent: 40,
    minWidth: 320,
    render: (med) => (
      <ResourceTitleColumn
        title={<CopyToClipboard>{med.display}</CopyToClipboard>}
        capitalizeTitle={false}
        subTitle={med.dosage}
        renderIcon={RenderSyncedWithRecordIcon(med.ownedByBuilder(builderId))}
      />
    ),
  },
  {
    title: 'Dispensed',
    render: (medication) => (
      <div className={tw`stacked-concat`}>
        {medication.quantity && <div>{medication.quantity}</div>}
        {medication.refills && <div>{medication.refills} refills</div>}
      </div>
    ),
    widthPercent: 18,
    minWidth: 160,
  },
  {
    title: 'Last Filled',
    render: (medication) =>
      medication.lastFillDate && (
        <div>
          <span>Last Filled: </span>
          {medication.lastFillDate}
        </div>
      ),
    widthPercent: 18,
  },
  {
    title: 'Last Prescribed',
    render: (medication) => {
      const { lastPrescribedDate, lastPrescriber } = medication;

      if (!(lastPrescribedDate || lastPrescriber)) {
        return null;
      }

      return (
        <div className={tw`stacked-concat`}>
          <span>Last Prescribed: </span>
          {lastPrescribedDate && <div>{lastPrescribedDate}</div>}
          {lastPrescriber && <div>{lastPrescriber}</div>}
        </div>
      );
    },
    widthPercent: 18,
    minWidth: 90,
  },
];
